import { Organization } from './organization.model';
import { Project } from './project.model';
import { Task } from './task.model';
import { User } from './user.model';
import { Document } from './document.model';

export enum DelayUnitOfMeasure {
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
}

export enum IncidentType {
  WEATHER = 'WEATHER',
  ACCIDENT = 'ACCIDENT',
  MATERIALS_ISSUE = 'MATERIALS_ISSUE',
  EQUIPMENT_ISSUE = 'EQUIPMENT_ISSUE',
  OTHER = 'OTHER',
}

export enum IncidentStatus {
  PENDING = 'PENDING',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
}

export interface Incident {
  incidentId: string;
  name: string;
  description?: string;
  incidentTime?: string | Date;
  delay?: number;
  delayUnitOfMeasure?: DelayUnitOfMeasure;
  incidentType?: IncidentType;
  otherIncidentType?: string;
  status: IncidentStatus;
  acknowledgedByUser?: User;
  acknowledgedBy?: string;
  acknowledgedAt?: string | Date;
  user: User;
  userId: string;
  project?: Project;
  projectId?: string;
  organization?: Organization;
  organizationId: string;
  tasks?: Task[];
  documents?: Document[];
  createdAt: string | Date;
  attemptAt?: string | Date;
}

export interface GetIncidentsRequest {
  getIncidentsByProject?: Incident[];
  getIncidentsByTask?: Incident[];
  getIncidentsByOrganization?: Incident[];
  getPendingIncidents?: Incident[];
  getIncidentsByStatus?: Incident[];
  getIncident?: Incident;
}

export interface CreateIncidentRequest {
  createIncident: Incident;
}

export interface UpdateIncidentRequest {
  updateIncident: Incident;
}

export interface AcknowledgeIncidentRequest {
  acknowledgeIncident: Incident;
}
